import { formatDate } from './emailUtils';

function EmailLogs({ logs }) {
  return (
    <div className="admin-panel email-log-panel">
      <h2>Email logs</h2>
      <div className="email-log-list">
        {logs.slice(0, 8).map((log) => (
          <article className="email-log-row" key={log._id}>
            <span className="email-log-row__subject">{log.subject}</span>
            <span>{log.type}</span>
            <span>
              Sent {log.successCount} / Failed {log.failedCount}
            </span>
            <span>
              {log.groupName
                ? `${log.groupName}: ${log.sentCount || log.successCount}/${log.totalRecipients || 0}, skipped ${
                    log.skippedUnsubscribedCount || 0
                  }`
                : `Skipped ${log.skippedUnsubscribedCount || 0}`}
            </span>
            <span>
              Limit {log.bulkLimitUsed || '-'} / Delay {log.delayMsUsed ?? '-'}ms / Invalid {log.invalidCount || 0}
            </span>
            <span>{formatDate(log.createdAt)}</span>
            {log.failures?.length ? (
              <small className="email-log-row__failures">
                Failed: {log.failures.map((failure) => failure.email).join(', ')}
              </small>
            ) : null}
          </article>
        ))}
        {logs.length === 0 ? <p className="admin-empty">No admin emails sent yet.</p> : null}
      </div>
    </div>
  );
}

export default EmailLogs;
